module.exports = __webpack_public_path__ + "img/d-max-zh.47544f8b.png";